export default __webpack_public_path__ + "static/media/activity_email.e0b6646e.svg";